import Billing from './index.vue'

export default [
  { path: '/invoices', component: Billing, meta: { auth: true } }
]